import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const startBatchCompetitorCandidateValidation = unaryRpc({
  name: "startBatchCompetitorCandidateValidation",
  input: z.object({ teamIds: z.array(z.string()).optional() }),
  output: z.object({
    workflowId: z.string(),
    status: z.literal("started"),
    teamsQueued: z.number(),
    teamsSkipped: z.number(),
  }),
});
